export default __webpack_public_path__ + "static/media/ai_mic.ff5a4026.svg";